import { Button } from "@/_components/lib/ui/button";
import { PropsWithChildren } from "react";
import GoogleLogo from "@/_images/google-logo.png";
import Image from "next/image";

interface Props extends PropsWithChildren {
  onClick?: () => void;
}

export const GoogleButton = (props: Props) => {
  return (
    <Button
      variant="outline"
      size="lg"
      w="full"
      h="48px"
      borderRadius="3xl"
      onClick={props.onClick}
      fontSize="sm"
      colorPalette="neutral"
      color="neutral.700"
      bg="neutral.50"
      borderColor="neutral.300"
      _hover={{
        bg: "neutral.100",
        color: "neutral.900",
      }}
      _active={{
        bg: "neutral.100",
        color: "neutral.900",
      }}
      _disabled={{
        bg: "neutral.50",
        color: "neutral.700",
      }}
      _focus={{
        bg: "neutral.100",
        color: "neutral.900",
      }}
    >
      <Image src={GoogleLogo} alt="google" height={26} width={26} />
      {props.children}
    </Button>
  );
};
